import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./assets/tailwind.css";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

Vue.config.productionTip = false;

Vue.prototype.$doc = (data) => {
  return document.querySelector(data);
};

Vue.prototype.$localStorage = () => {
  return localStorage;
};

Vue.prototype.$time = (time) => {
  let date = new Date(time);
  return `${date.getHours().toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
};

// Ready translated locale messages
const messages = {
  en: {
    fixed: {
      cancel: "Cancel",
      code: "Code :",
      ordersEm: "there is no orders",
      favoritePsEm: "there is no favorites products",
      favoritePs: "Favorites products",
      alert: {
        canceled: "your order has been canceled successfully",
        cancel: "do you really want to cancel your order ?!",
        disCreated: "The order has the code {code}",
        created: "Your order has been created successfully",
        done: "Congratulations",
        creating: "The order is being created ...",
        askNotice: "do you want to get notification about your order",
        notification: "Notification",
        geolocation: "do you want to use geolocation api to get your location",
        location: "Location",
        confirm:
          "Are you sure of your order information and delivery information",
      },
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      category: {
        group: "Categorys",
        summer: "Summer",
        trending: "trending",
        tshirts: "t-shirts",
        shoes: "shoes",
        watches: "watches",
        sports: "sport",
        empty: "there is no products in this category",
      },
      quantity: "Quantity",
      size: "Size",
      totalP: "The total price for this product is",
      standard: "Standard",
      cart: {
        title: "Cart",
        empty: "cart is empty",
        delivery: "Delivery",
        order: "Order",
        infoD: "Delivery info",
        infoO: "Order info",
        productsN: "number of products :",
        deliveryP: "delivery price :",
        free: "free",
        totalP: "total price :",
        paymentM: "Payment method :",
        receipt: "Upon receipt",
      },
      menu: {
        title: "MENU",
        favorite: "Favorite",
        orders: "Orders",
        install: "Install App",
        theme: "Theme",
        dark: "DARK",
        light: "LIGHT",
        language: "Language",
      },
      product: {
        group: "Products",
      },
      input: {
        name: "Enter your full name here",
        phone: "Enter your phone number here",
        place: "Describe your delivery location well here",
        req: "Fill the following tanks with the correct information to complete the order",
      },
    },
    start: {
      title: "Style for Summer",
      dis: "Make the most of those long summer days, with essentials for the season.",
      button: "Shop",
    },
    home: {
      banner: {
        title: "Summertime",
        dis: "means more time at <br> the beach !",
      },
      slogan: {
        title: "Great man",
        dis: "deserves great clothes.",
        sub: "Let's do it",
      },
    },
  },
  ar: {
    fixed: {
      cancel: "إلغاء",
      code: "الرمز :",
      ordersEm: "لا توجد طلبات",
      favoritePsEm: "لا توجد منتجات مفضلة",
      favoritePs: "المنتجات المفضلة",
      alert: {
        canceled: "تم إلغاء طلبك بنجاح",
        cancel: "هل حقا تريد الغاء طلبك ؟!",
        disCreated: "الطلب يحمل الرمز {code}",
        created: "تم إنشاء طلبك بنجاح",
        done: "تهانينا",
        creating: "يتم إنشاء الطلب ...",
        askNotice: "هل ترغب في الحصول على إشعار بخصوص طلبك",
        notification: "الإشعارات",
        geolocation:
          "هل تريد استخدام واجهة برمجة تطبيقات تحديد الموقع الجغرافي للحصول على موقعك",
        location: "الموقع",
        confirm: "هل أنت متأكد من معلومات طلبك ومعلومات التسليم",
      },
      confirm: "التأكيد",
      yes: "نعم",
      no: "لا",
      category: {
        group: "الفئات",
        summer: "الصيف",
        trending: "الشائع",
        tshirts: "القمصان",
        shoes: "الأحذية",
        watches: "الساعات",
        sports: "الرياضة",
        empty: "لا توجد منتجات في هذه الفئة",
      },
      quantity: "الكمية",
      size: "الحجم",
      totalP: "السعر الإجمالي لهذا المنتج هو",
      standard: "أساسي",
      cart: {
        title: "السلة",
        empty: "السلة فارغة",
        delivery: "التوصيل",
        order: "الطلب",
        infoD: "معلومات التوصيل",
        infoO: "معلومات الطلبية",
        productsN: "عدد من المنتجات :",
        deliveryP: "سعر تسليم :",
        free: "مجانا",
        totalP: "السعر الكلي :",
        paymentM: "طريقة الدفع :",
        receipt: "عند الاستلام",
      },
      menu: {
        title: "القائمة",
        favorite: "المفضلة",
        orders: "الطلبات",
        install: "تثبيت التطبيق",
        theme: "الوضع",
        dark: "داكن",
        light: "فاتح",
        language: "اللغة",
      },
      product: {
        group: "منتجات",
      },
      input: {
        name: "أدخل اسمك الكامل هنا",
        phone: "أدخل رقم هاتفك هنا",
        place: "صف موقع التسليم الخاص بك جيدا هنا",
        req: "املأ الخزانات التالية بالمعلومات الصحيحة لإكمال الطلب",
      },
    },
    start: {
      title: "أسلوب الصيف",
      dis: "حقق أقصى استفادة من أيام الصيف الطويلة تلك ، مع المستلزمات الضرورية للموسم.",
      button: "تسوق",
    },
    home: {
      banner: {
        title: "الصيف",
        dis: "يعني المزيد من الوقت على الشاطئ !",
      },
      slogan: {
        title: "رجل عظيم",
        dis: "يستحق ملابس عظيمة.",
        sub: "لنفعلها",
      },
    },
  },
  fr: {
    fixed: {
      cancel: "Annuler",
      code: "Code :",
      ordersEm: "il n'y a pas de commandes",
      favoritePsEm: "il n'y a pas de produits favoris",
      favoritePs: "Produits favoris",
      alert: {
        canceled: "votre commande a été annulée avec succès",
        cancel: "voulez-vous vraiment annuler votre commande ?!",
        disCreated: "La commande porte le code {code}",
        created: "Votre commande a été créée avec succès",
        done: "Félicitations",
        creating: "La commande est en cours de création ...",
        askNotice:
          "voulez-vous recevoir une notification concernant votre commande",
        notification: "Notification",
        geolocation:
          "voulez-vous utiliser l'API de géolocalisation pour obtenir votre position",
        location: "Emplacement",
        confirm:
          "Êtes-vous sûr de vos informations de commande et de livraison",
      },
      confirm: "Confirmer",
      yes: "Oui",
      no: "Non",
      category: {
        group: "Catégories",
        summer: "Été",
        trending: "tendance",
        tshirts: "t-shirts",
        shoes: "chaussures",
        watches: "montres",
        sports: "sport",
        empty: "il n'y a aucun produit dans cette catégorie",
      },
      quantity: "Quantité",
      size: "Taille",
      totalP: "Le prix total de ce produit est",
      standard: "Standard",
      cart: {
        title: "Panier",
        empty: "Le panier est vide",
        delivery: "Livraison",
        order: "Commande",
        infoD: "Infos livraison",
        infoO: "Infos commande",
        productsN: "nombre de produits :",
        deliveryP: "prix de livraison :",
        free: "libre",
        totalP: "prix total :",
        paymentM: "Mode de paiement :",
        receipt: "Dès réception",
      },
      menu: {
        title: "MENU",
        favorite: "Favorite",
        orders: "Commandes",
        install: "Install App",
        theme: "Thème",
        dark: "FONCÉE",
        light: "LUMIÈRE",
        language: "Langue",
      },
      product: {
        group: "Produits",
      },
      input: {
        name: "Entrez votre nom complet ici",
        phone: "Entrez votre numéro de téléphone ici",
        place: "Décrivez bien votre lieu de livraison ici",
        req: "Remplissez les réservoirs suivants avec les informations correctes pour compléter la commande",
      },
    },
    start: {
      title: "Style pour l'été",
      dis: "Profitez au maximum de ces longues journées d'été, avec des essentiels pour la saison.",
      button: "achats",
    },
    home: {
      banner: {
        title: "dasHeure d'été",
        dis: "signifie plus de temps à <br> la plage !",
      },
      slogan: {
        title: "Grand homme",
        dis: "mérite de beaux vêtements.",
        sub: "Faisons-le",
      },
    },
  },
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: localStorage.language ? localStorage.language : "en", // set locale
  messages, // set locale messages
});

new Vue({
  router,
  render: (h) => h(App),
  i18n,
}).$mount("#app");
